/**
 * 通配符配置接口 - 通用条件构建器配置
 * GET /api/wildcard-configs/index
 */
import { apiGet } from '@/utils/request';
import type { WildcardConfigItem } from '@/types/conditionBuilder';

/**
 * 获取通配符配置列表（树形结构）
 * @param scene 使用场景，用于按场景过滤可用条件字段；不传返回全部。
 *   目前特殊场景：reach_plan（触达计划）、greeting_first（开口引导语·首次进线）、
 *   user_assign（坐席分组·自定义分配）
 * @param robotId 机器人 ID。实体等字段的可选项按 Agent 类型区分，
 *   Agent 内的条件组必须传，否则会拿到其它 Agent 类型的实体；
 *   Agent 之外的场景（触达计划、推送配置、坐席分组等）不传。
 */
export function queryWildcardConfigs(
  scene?: string,
  robotId?: number,
): Promise<WildcardConfigItem[]> {
  const params: Record<string, unknown> = {};
  if (scene) params.scene = scene;
  if (robotId != null) params.robot_id = robotId;
  return apiGet('/wildcard-configs/index', params).then((d) => (Array.isArray(d) ? d : []));
}
